module.exports = __webpack_public_path__ + "img/picture_07.d3fbc944.png";